import { Col, Row } from "antd"
import moment from "moment"
import { InvoiceType } from "src/utils/commonInterfaces"
export default function TaxInvoiceView({ invoiceData }: any) {

    return (
        <div
            style={{
                backgroundColor: "white",
                fontFamily: "Arial, sans-serif",
                fontSize: "14px",
                lineHeight: "1.6",
                color: "#333",
                boxSizing: "border-box",
                padding: "40px 60px",
                maxWidth: "1000px",
                margin: "0 auto",
            }}
        >
            {/* Simple Header */}
            <div
                style={{
                    textAlign: "center",
                    marginBottom: "30px",
                    paddingBottom: "15px",
                    borderBottom: "2px solid #ccc",
                }}
            >
                <h1
                    style={{
                        fontSize: "32px",
                        fontWeight: "bold",
                        // margin: "0 0 10px 0",
                        color: "#333",
                        letterSpacing: "0.5px",
                    }}
                >
                    فاتورة ضريبية
                </h1>
                <h2
                    style={{
                        fontSize: "24px",
                        fontWeight: "normal",
                        margin: "0",
                        color: "#666",
                    }}
                >
                    TAX INVOICE
                </h2>
            </div>

            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "30px",
                    marginBottom: "40px",
                }}
            >
                <div
                    style={{
                        padding: "7px 25px",
                        backgroundColor: "#f5f5f5",
                        border: "1px solid #ddd",
                    }}
                >
                    <div style={{ marginBottom: "15px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <div style={{ fontWeight: "bold", fontSize: "14px", color: "#444" }}>
                            From: {invoiceData?.sellerName?.trim() || 'N/A'}
                        </div>
                        <div style={{ direction: "rtl", textAlign: "right", fontWeight: "bold", fontSize: "14px", color: "#444" }}>
                            من: {invoiceData?.sellerNameAr?.trim() || 'N/A'}
                        </div>
                    </div>
                    <div style={{ marginBottom: "8px" }}>
                        <Row>
                            <Col span={8}>
                                <div style={{ direction: "ltr", textAlign: "left", fontWeight: "bold", fontSize: "13px" }}>
                                    Issue Date:
                                </div>

                            </Col>
                            <Col span={8}>
                                <div style={{ textAlign: "center", fontSize: "13px" }}>
                                    {moment(invoiceData?.issueDate).format('LL')}
                                </div>
                            </Col>
                            <Col span={8}>
                                <div style={{ direction: "rtl", textAlign: "right", fontWeight: "bold", fontSize: "13px" }}>
                                    تاريخ الإصدار:
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <div style={{ marginBottom: "8px", display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div style={{ whiteSpace: "pre-line", fontWeight: "bold", maxWidth: "240px" }}>
                            Address:<span style={{ fontWeight: "normal" }}>{invoiceData?.sellerAddress?.trim() || 'N/A'}</span>
                        </div>
                        <div style={{ direction: "rtl", textAlign: "right", fontWeight: "bold", maxWidth: "210px" }}>
                            العنوان: <span style={{ fontWeight: "normal" }}>{invoiceData?.sellerAddressAr?.trim() || 'N/A'}</span>
                        </div>
                    </div>

                    <div style={{ marginBottom: "8px" }}>
                        <Row>
                            <Col span={8}>
                                <div style={{ direction: "ltr", textAlign: "left", fontWeight: "bold" }}>
                                    Invoice Number:
                                </div>
                            </Col>
                            <Col span={8}>
                                <div style={{ textAlign: "center" }}>
                                    {invoiceData?.creditSerialNumber ?? invoiceData?.invoiceSerialNumber}
                                </div>
                            </Col>
                            <Col span={8}>
                                <div style={{ direction: "rtl", textAlign: "right", fontWeight: "bold" }}>
                                    رقم الفاتورة:
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div style={{ marginBottom: "8px" }}>
                        <Row>
                            <Col span={8}>
                                <div style={{ direction: "ltr", textAlign: "left", fontWeight: "bold" }}>
                                    TAX Identification Number:
                                </div>
                            </Col>
                            <Col span={8}>
                                <div style={{ textAlign: "center", fontWeight: "bold" }}>
                                    {invoiceData?.sellerTaxIdentificationNumber?.trim() || 'N/A'}
                                </div>
                            </Col>
                            <Col span={8}>
                                <div style={{ direction: "rtl", textAlign: "right", fontWeight: "bold" }}>
                                    رقم التعريف الضريبي:
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

                <div
                    style={{
                        padding: "10px 25px",
                        backgroundColor: "#f5f5f5",
                        border: "1px solid #ddd",
                    }}
                >
                    <div style={{ marginBottom: "15px" }}>
                        <Row>
                            <Col span={8}>
                                <div style={{ direction: "ltr", textAlign: "left", fontWeight: "bold", fontSize: "14px", color: "#444" }}>
                                    To:
                                </div>
                            </Col>
                            <Col span={8}>
                                <div style={{ textAlign: "center", fontSize: "15px" }}>
                                    {invoiceData?.invoiceTypeID === InvoiceType.B2C_INVOICE ? invoiceData?.userName : invoiceData?.legalName === null ? invoiceData?.to?.trim() : invoiceData?.legalName?.trim() || 'N/A'}
                                </div>
                            </Col>
                            <Col span={8}>
                                <div style={{ direction: "rtl", textAlign: "right", fontWeight: "bold", fontSize: "14px", color: "#444" }}>
                                    الي:
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div style={{ marginBottom: "8px" }}>
                        <Row>
                            <Col span={8}>
                                <div style={{ direction: "ltr", textAlign: "left", fontWeight: "bold" }}>
                                    Address:
                                </div>
                            </Col>
                            <Col span={8}>
                                <div style={{ direction: "rtl", textAlign: "center", fontSize: "15px" }}>
                                    {invoiceData?.invoiceTypeID === InvoiceType.B2C_INVOICE ? invoiceData?.userCity?.trim() : invoiceData?.buyerAddress?.trim() || 'N/A'}
                                </div>
                            </Col>
                            <Col span={8}>
                                <div style={{ direction: "rtl", textAlign: "right", fontWeight: "bold" }}>
                                    العنوان:
                                </div>
                            </Col>
                        </Row>
                    </div>
                    {invoiceData?.buyerTaxIdentificationNumber &&
                        invoiceData?.invoiceTypeID !== InvoiceType.B2C_INVOICE ?
                        <div style={{ marginBottom: "8px" }}>
                            <Row>
                                <Col span={8}>
                                    <div style={{ direction: "ltr", textAlign: "left", fontWeight: "bold" }}>
                                        Tax Identification Number:
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div style={{ textAlign: "center", fontWeight: "bold" }}>
                                        {invoiceData?.buyerTaxIdentificationNumber}
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div style={{ direction: "rtl", textAlign: "right", fontWeight: "bold" }}>
                                        رقم التعريف الضريبي :
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        : null}
                </div>
            </div>

            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "40px",
                    border: "2px solid #ccc",
                }}
            >
                <thead>
                    <tr>
                        <th
                            style={{
                                border: "1px solid #ccc",
                                padding: "15px 10px",
                                backgroundColor: "#e8e8e8",
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "#444",
                            }}
                        >
                            <div style={{ direction: "rtl" }}>الإجمالي ريال سعودي</div>
                            <div style={{ marginTop: "3px" }}>Total Price</div>
                        </th>
                        <th
                            style={{
                                border: "1px solid #ccc",
                                padding: "15px 10px",
                                backgroundColor: "#e8e8e8",
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "#444",
                            }}
                        >
                            <div style={{ direction: "rtl" }}>قيمة الضريبة</div>
                            <div style={{ marginTop: "3px" }}>VAT</div>
                        </th>
                        <th
                            style={{
                                border: "1px solid #ccc",
                                padding: "15px 10px",
                                backgroundColor: "#e8e8e8",
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "#444",
                            }}
                        >
                            <div style={{ direction: "rtl" }}>النسبة المئوية</div>
                            <div style={{ marginTop: "3px" }}>VAT %</div>
                        </th>
                        <th
                            style={{
                                border: "1px solid #ccc",
                                padding: "15px 10px",
                                backgroundColor: "#e8e8e8",
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "#444",
                            }}
                        >
                            <div style={{ direction: "rtl" }}>السعر بدون ضريبة</div>
                            <div style={{ marginTop: "3px" }}>Total Excl. VAT</div>
                        </th>
                        <th
                            style={{
                                border: "1px solid #ccc",
                                padding: "15px 10px",
                                backgroundColor: "#e8e8e8",
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "#444",
                                width: "35%",
                            }}
                        >
                            <div style={{ direction: "rtl" }}>وصف الصنف</div>
                            <div style={{ marginTop: "3px" }}>Item Description</div>
                        </th>
                        <th
                            style={{
                                border: "1px solid #ccc",
                                padding: "15px 10px",
                                backgroundColor: "#e8e8e8",
                                textAlign: "center",
                                fontSize: "12px",
                                fontWeight: "bold",
                                color: "#444",
                            }}
                        >
                            <div style={{ direction: "rtl" }}>التسلسلي</div>
                            <div style={{ marginTop: "3px" }}>Ser.</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td
                            style={{
                                border: "1px solid #ccc",
                                padding: "15px 10px",
                                textAlign: "center",
                                fontWeight: "normal",
                                color: "#333",
                                fontSize: "13px",
                            }}
                        >
                            {invoiceData?.total ?? 'N/A'}
                        </td>
                        <td
                            style={{
                                border: "1px solid #ccc",
                                padding: "15px 10px",
                                textAlign: "center",
                                fontWeight: "normal",
                                color: "#333",
                                fontSize: "13px",
                            }}
                        >
                            {invoiceData?.total && invoiceData?.totalRevenueExclVAT
                                ? (invoiceData?.total - invoiceData?.totalRevenueExclVAT).toFixed(2)
                                : 'N/A'}
                        </td>
                        <td
                            style={{
                                border: "1px solid #ccc",
                                padding: "15px 10px",
                                textAlign: "center",
                                fontWeight: "normal",
                                color: "#333",
                                fontSize: "13px",
                            }}
                        >
                            {invoiceData?.VATPercent ?? 'N/A'}
                        </td>
                        <td
                            style={{
                                border: "1px solid #ccc",
                                padding: "15px 10px",
                                textAlign: "center",
                                fontWeight: "normal",
                                color: "#333",
                                fontSize: "13px",
                            }}
                        >
                            {invoiceData?.totalRevenueExclVAT ?? 'N/A'}
                        </td>
                        <td
                            style={{
                                border: "1px solid #ccc",
                                padding: "15px 10px",
                                textAlign: "center",
                                fontWeight: "normal",
                                color: "#333",
                                fontSize: "13px",
                            }}
                        >
                            {invoiceData?.itemDescriptionEn?.trim() || 'N/A'}
                        </td>
                        <td
                            style={{
                                border: "1px solid #ccc",
                                padding: "15px 10px",
                                textAlign: "center",
                                fontWeight: "normal",
                                color: "#333",
                                fontSize: "13px",
                            }}
                        >
                            {invoiceData?.invoiceSerialNumber?.trim() || 'N/A'}
                        </td>
                    </tr>
                </tbody>
            </table>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                }}
            >
                <table
                    style={{
                        borderCollapse: "collapse",
                        border: "2px solid #ccc",
                        width: "300px",
                    }}
                >
                    <tbody>
                        <tr>
                            <td
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "12px",
                                    textAlign: "center",
                                    fontWeight: "bold",
                                    color: "#333",
                                    fontSize: "14px",
                                }}
                            >
                                {invoiceData?.totalRevenueExclVAT ?? 'N/A'}
                            </td>
                            <td
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "12px",
                                    textAlign: "center",
                                    backgroundColor: "#e8e8e8",
                                    color: "#444",
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                }}
                            >
                                <div style={{ direction: "rtl" }}>الإجمالي بدون ضريبة</div>
                                <div>Total excl. VAT</div>
                            </td>
                        </tr>
                        <tr>
                            <td
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "12px",
                                    textAlign: "center",
                                    fontWeight: "bold",
                                    color: "#333",
                                    fontSize: "14px",
                                }}
                            >
                                {invoiceData?.total && invoiceData?.totalRevenueExclVAT
                                    ? (invoiceData.total - invoiceData.totalRevenueExclVAT).toFixed(2)
                                    : 'N/A'}
                            </td>
                            <td
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "12px",
                                    textAlign: "center",
                                    backgroundColor: "#e8e8e8",
                                    color: "#444",
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                }}
                            >
                                <div style={{ direction: "rtl" }}>ضريبة القيمة المضافة</div>
                                <div>VAT</div>
                            </td>
                        </tr>
                        <tr>
                            <td
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "12px",
                                    textAlign: "center",
                                    fontWeight: "bold",
                                    color: "#333",
                                    fontSize: "14px",
                                }}
                            >
                                {invoiceData?.total ?? 'N/A'}
                            </td>
                            <td
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "12px",
                                    textAlign: "center",
                                    backgroundColor: "#e8e8e8",
                                    color: "#444",
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                }}
                            >
                                <div style={{ direction: "rtl" }}>الإجمالي</div>
                                <div>Total</div>
                            </td>
                        </tr>
                        <tr>
                            <td
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "12px",
                                    textAlign: "center",
                                    fontWeight: "bold",
                                    color: "#333",
                                    fontSize: "14px",
                                }}
                            >
                                {/* balance due  */}
                                {invoiceData?.total ?? 'N/A'}
                            </td>
                            <td
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "12px",
                                    textAlign: "center",
                                    backgroundColor: "#e8e8e8",
                                    color: "#444",
                                    fontWeight: "bold",
                                    fontSize: "12px",
                                }}
                            >
                                <div style={{ direction: "rtl" }}>الرصيد المستحق</div>
                                <div>Balance Due</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Simple Footer */}
            <div
                style={{
                    marginTop: "27px",
                    paddingTop: "15px",
                    borderTop: "1px solid #ddd",
                    textAlign: "center",
                    color: "#999",
                    fontSize: "9px",
                }}
            >
                <p style={{ margin: "3px 0", direction: "rtl" }}>
                    هذه فاتورة إلكترونية ولا تحتاج إلى توقيع
                </p>
                <p style={{ margin: "3px 0" }}>
                    This is a computer-generated invoice
                </p>
            </div>
        </div>
    )
}
